module.exports = __webpack_public_path__ + "static/media/userGroupAvatar.db33c121.svg";